/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_privacy_section_3_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`We use the information we collect to:`)
};

const es_privacy_section_3_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Usamos la información que recopilamos para:`)
};

const de_privacy_section_3_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wir verwenden die erfassten Informationen, um:`)
};

const nl_privacy_section_3_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`We gebruiken de verzamelde informatie om:`)
};

const fr_privacy_section_3_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nous utilisons les informations collectées pour :`)
};

const it_privacy_section_3_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Utilizziamo le informazioni che raccogliamo per:`)
};

const pt_br2_privacy_section_3_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Usamos as informações que coletamos para:`)
};

const pt_privacy_section_3_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Utilizamos a informação que recolhemos para:`)
};

const ja_privacy_section_3_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`収集した情報は以下の目的で使用します:`)
};

const zh_privacy_section_3_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`我们使用收集的信息用于：`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const privacy_section_3_intro = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.privacy_section_3_intro(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("privacy_section_3_intro", locale)
	if (locale === "en") return en_privacy_section_3_intro(inputs)
	if (locale === "es") return es_privacy_section_3_intro(inputs)
	if (locale === "de") return de_privacy_section_3_intro(inputs)
	if (locale === "nl") return nl_privacy_section_3_intro(inputs)
	if (locale === "fr") return fr_privacy_section_3_intro(inputs)
	if (locale === "it") return it_privacy_section_3_intro(inputs)
	if (locale === "pt-BR") return pt_br2_privacy_section_3_intro(inputs)
	if (locale === "pt") return pt_privacy_section_3_intro(inputs)
	if (locale === "ja") return ja_privacy_section_3_intro(inputs)
	return zh_privacy_section_3_intro(inputs)
};